import { __commonJSMin as e } from "../../../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0_canvas@3.2.0_/node_modules/@intercom/intercom-sanitizer/dist/html/config/default.js
var t = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.DEFAULT_CONFIG = void 0;
	var t = [
		"ic-attribute",
		"ic-block",
		"ic-marker",
		"ic-mention"
	];
	e.DEFAULT_CONFIG = {
		ADD_TAGS: ["iframe"],
		ADD_ATTR: [
			"allowfullscreen",
			"frameborder",
			"target"
		],
		CUSTOM_ELEMENT_HANDLING: {
			tagNameCheck: function(e) {
				return t.includes(e);
			},
			attributeNameCheck: /^(data-|contenteditable)/,
			allowCustomizedBuiltInElements: !1
		}
	};
}));
//#endregion
export default t();
export { t as require_default };
